import { NotificationModel } from "./NotificationModel";


//Ajout
export const ajoutSucces: NotificationModel = {
    message: "Ajout effectué avec succès",
    severity: "success",
    title: "Succès"
};
export const ajoutError: NotificationModel = {
    message: "Erreur lors de l'ajout",
    severity: "error",
    title: "Erreur"
};

//modif
export const modifSucces: NotificationModel = {
    message: "Modification effectuée avec succès",
    severity: "success",
    title: "Succès"
};

export const modifError: NotificationModel = {
    message: "Erreur lors de la modification",
    severity: "error",
    title: "Erreur"
};

//supprimer
export const supprSucces: NotificationModel = {
    message: "Supression effectuée avec succès",
    severity: "success",
    title: "Succès"
};
export const supprError: NotificationModel = {
    message: "Erreur lors de la supression",
    severity: "error",
    title: "Erreur"
};

//Annulation
export const annulationWarning: NotificationModel = {
    message: "Opération annulée",
    severity: "warning",
    title: "Information"
};
//get Propertie
export const getPropertyError: NotificationModel = {
    message: "Erreur lors de la récupération du champ",
    severity: "error",
    title: "Erreur"
};

//chargement formulaire
export const loadFormError : NotificationModel = {
    message : "Erreur pendant le remplissage du formulaire",
    severity: "error",
    title : "Erreur"
}

//chargement de la table
export const loadTableError : NotificationModel = {
    message : "Erreur pendant la récupération des données",
    severity : "error",
    title : "Error"
}

export const loginError : NotificationModel = {
    message : "Erreur pendant l'autentification",
    severity : "error",
    title : "Error"
}
